<template>
  <div>
     <div>
     <v-row justify="center">
     <v-dialog v-model="dialog" persistent max-width="390">
       <v-card>
         <v-card-title class="headline">Selecione o Trimestre</v-card-title>
          <v-col
             cols="12"
             md="12"
           >
             <v-select
               v-model="trimestre"
               item-value="idTrimestre"
               item-text="descricao"
               :items="trimestres"
               :disabled="isUpdating"
                filled
               color="blue-grey lighten-2"
               label="Trimestre"
               return-object
             ></v-select>
           </v-col>
           <v-card-actions>
           <v-spacer></v-spacer>
           <v-btn color="red darken-1" text @click="dialog=false">Cancelar</v-btn>
            <v-btn color="green darken-1" text :disabled="!trimestre" @click="carregarRelatorio()">Avançar</v-btn>
         </v-card-actions>
       </v-card>
     </v-dialog>
   </v-row>
   </div>
    <br>
    <v-card class="mx-auto"> 
     <v-toolbar color="indigo" dark>
       <v-app-bar-nav-icon></v-app-bar-nav-icon>
         
       <v-toolbar-title>Aluno :  {{this.$store.state.objAluno.nome}} - {{this.$store.state.objAluno.idMAtricula}}</v-toolbar-title>
 
       <v-spacer></v-spacer>
 
       <v-btn icon>
         <v-icon>mdi-magnify</v-icon>
       </v-btn>
     </v-toolbar>
 
     <v-container fluid>
       <v-row dense>
         <v-col xs="12" sm="12" md="12"> 
           <strong>Geração de Boletim</strong>
            <v-icon @click="escolherOTrimestre()" color="primary">print</v-icon>
            <v-progress-circular v-if="progresso" indeterminate color="green"></v-progress-circular>
           <v-card>
 
   <template>
       <v-simple-table class="tabela" fixed-header>
        <template v-slot:default>
         <thead>
         <tr>
 
         </tr>
       </thead>
 
       <tbody>
           <tr>
              <td rowspan="2" class="tabelath">Nº</td>
              <td rowspan="2" class="tabelath">Disciplina</td>
              <td colspan="4" class="tabelath">1º Trimestre</td>
             <td colspan="4" class="tabelath">2º Trimestre</td>
             <td colspan="3" class="tabelath">3º Trimestre</td>
             <td colspan="4" class="tabelath">Médias</td>
           </tr>
           <tr>
             <td  class="tabela">MAC</td>
             <td  class="tabela">P1</td>
             <td class="tabela">P2</td>
             <td class="tabela">MT</td>

             <td class="tabela">MAC</td>
             <td class="tabela">P1</td>
             <td class="tabela">P2</td>
             <td class="tabela">MT</td>

             <td class="tabela">MAC</td>
             <td class="tabela">P1</td>
             <!-- <td class="tabela">P2</td> -->
             <td class="tabela">MT</td>

             <td class="tabela">MFD</td> 
             <td class="tabela"> {{$store.state.objAluno.idAno_Academico > 2 ? 'EX' : 'PG' }}</td>
             <td class="tabela">REC</td>
             <td class="tabela">MF</td>
             
         </tr>
         <tr v-for="(item,i) in listaAlunos" :key="i">
           <td  class="tabela">{{ i+1 }}</td>
           <td  class="tabela">{{ item.disciplina }}</td>
           <td  class="tabela">{{ item.t1_mac }}</td>
           <td  class="tabela">{{ item.t1_nota1 }}</td>
           <td  class="tabela">{{ item.t1_nota2 }}</td>
           <td v-if="(!item.t1_md || item.t1_md <10)" style="color:red" class="tabela">{{ item.t1_md }}</td>
           <td v-if="(item.t1_md >=10)" style="color:blue" class="tabela">{{ item.t1_md }}</td>

           <td  class="tabela">{{ item.t2_mac }}</td>
           <td  class="tabela">{{ item.t2_nota1 }}</td>
           <td  class="tabela">{{ item.t2_nota2 }}</td>

           <td v-if="(!item.t2_md || item.t2_md <10)" style="color:red" class="tabela">{{ item.t2_md }}</td>
           <td v-if="(item.t2_md>=10)" style="color:blue" class="tabela">{{ item.t2_md }}</td>

           <td  class="tabela">{{ item.t3_mac }}</td>
           <td  class="tabela">{{ item.t3_nota1 }}</td>
           <!-- <td  class="tabela">{{ item.t3_nota2 }}</td> -->

           <td v-if="(!item.t3_md || item.t3_md <10)" style="color:red" class="tabela">{{ item.t3_md }}</td>
           <td v-if="(item.t3_md>=10)" style="color:blue" class="tabela">{{ item.t3_md }}</td>

           

           <td v-if="(!item.mf  || item.mf < 10)" style="color:red" class="tabela">{{ item.mf }}</td>
           <td v-if="(item.mf >=10)" style="color:blue" class="tabela">{{ item.mf }}</td>

           <td v-if="(!item.pg || item.pg < 10)" style="color:red" class="tabela">{{ item.pg }}</td>
           <td v-if="(item.pg >= 10)" style="color:blue" class="tabela">{{ item.pg }}</td>

           <td v-if="(!item.recurso || item.recurso  < 10)" style="color:red" class="tabela">{{ item.recurso }}</td>
           <td v-if="(item.recurso >=10)" style="color:blue" class="tabela">{{ item.recurso }}</td>

           
           <td v-if="(!item.mfd || item.mfd < 10)" class="tabela" style="color:red">{{ item.mfd }}</td>
           <td v-if="(item.mfd >= 10)" style="color:blue" class="tabela">{{ item.mfd }}</td>
 
            </tr>
          </tbody>
        </template>
      </v-simple-table>
   </template>
 
           </v-card>
         </v-col>
          <!--   --> 
          <v-col md="0"> </v-col>
       </v-row>
   <!-- =============================================================================== -->
     </v-container>
   </v-card>
  </div>
 </template>
 <script>
 import axios from '../../plugins/axios'
 import utilitario from '../../plugins/utilitarios'
 import Swal from 'sweetalert2'
 const ls = require('local-storage')
 export default {
   data: () => ({
     israscunho: true,
     pagamento: [],
     configuracoesReport: [],
     insignia: ls.get('insignia'),
     logotipo: ls.get('logotipo'),
     progresso: false,
     listaAlunos: [],
     html: ``,
     url: '',
     arrayTrimestreFirst: [],
     arrayTrimestreSecond: [],
     arrayTrimestreThird: [],
     dialog: false,
     isUpdating: false,
     trimestre: null,
     rascunhoimge: '',
     relatorio: [],
     anoAcademicos: [
       { idAno_academico: 1, descricao: '10ª' },
       { idAno_academico: 2, descricao: '11ª' },
       { idAno_academico: 3, descricao: '12ª' },
       { idAno_academico: 4, descricao: '13ª' }
     ],
     trimestres: [
     { idTrimestre: 1, descricao: '1º Trimestre', relatorio: 'bt' },
     { idTrimestre: 2, descricao: '2º Trimestre', relatorio: 'bt' },
     { idTrimestre: 3, descricao: '3º Trimestre', relatorio: 'b3t' },
     { idTrimestre: 4, descricao: 'Todos', relatorio: 'bg' }
     ]
   }),
   computed: {

          instituicaodescricao() {
               return ls.get('instituicaodescricao')
          },

          instituicaoId() {
               return ls.get('i_id')
          }

     },
   created () {
     this.carregarPagamento()
     this.CarregaBoletim()
     this.carregarConfiguracoesReports()     
   },
 
   methods: {
     async carregarPagamento () {
       try {
         let params = { anolectivo: this.$store.state.objAluno.anoLectivo,idemolumento: 1 }
         this.pagamento = await axios.post('/getPagamentosEmolumentosByEmolumento', params).then(res => res.data)  
         this.rascunhoimge = this.rascunho()
       } catch (error) {
         Swal.fire({ icon: 'error',title: 'Informação!', text: 'Ocorreu um erro ao carregar pagamento'})
       }
     },
     async carregarRelatorio () {
       try {         
         this.relatorio = await axios.get('/obterRelatorioByDescricao/' + this.trimestre.relatorio).then(res => res.data)       
         if(this.relatorio.length){
           this.comporBoletim()
         } else {
          Swal.fire({icon: 'info', title: '', text: 'Boletim não configurado!'})
         }
       } catch (error) {
         Swal.fire({icon: 'error',title: 'Informação!', text: 'Ocorreu um erro ao carregar o relatório'})
       }
     },
     async CarregaBoletim () {
       this.progresso = true
 
       const valor =
           {
             matricula: this.$store.state.objAluno.idMAtricula,
             ano: this.$store.state.objAluno.anoLectivo,
             pkInscricao_na_turma: this.$store.state.objAluno.pkInscricao_na_turma
           }
 
       try {
         this.listaAlunos = await axios.post('/gerarBoletim', valor).then(res => res.data)
         this.progresso = false
         if (this.listaAlunos.length > 0) { this.listaAlunos = this.listaAlunos[0] }
         this.filterBoletimAlunos(this.listaAlunos)
       } catch (error) {
         this.progresso = false
         Swal.fire({icon: 'error',title: 'Informação!', text: 'Ocorreu um erro ao carregar ao carregar o Boletim'})
       }
     },
     async filterBoletimAlunos (arrayAllPauta) {
       for (let i = 0; i < arrayAllPauta.length; i++) {
         this.arrayTrimestreFirst.push({ disciplina: arrayAllPauta[i].disciplina, mac: arrayAllPauta[i].t1_mac, p1: arrayAllPauta[i].t1_nota1, p2: arrayAllPauta[i].t1_nota2, md: arrayAllPauta[i].t1_md })
         this.arrayTrimestreSecond.push({ disciplina: arrayAllPauta[i].disciplina, mac: arrayAllPauta[i].t2_mac, p1: arrayAllPauta[i].t2_nota1, p2: arrayAllPauta[i].t2_nota2, md: arrayAllPauta[i].t2_md })
         this.arrayTrimestreThird.push({ disciplina: arrayAllPauta[i].disciplina, mac: arrayAllPauta[i].t3_mac, p1: arrayAllPauta[i].t3_nota1, md: arrayAllPauta[i].t3_md })
       }
     },
     escolherOTrimestre () {
       this.disabled = false
       this.dialog = true
     },
     rascunho () {
      try {
        const cobrancaboletim = this.$store.state.actividades.filter(t=>t.descricao === "Cobrança de Boletim")
        let iscobrancaboletim = true
      if(cobrancaboletim.length){
        iscobrancaboletim = (cobrancaboletim[0].status_2 == 1 ? true : false)
      }
      this.israscunho = (!iscobrancaboletim || (this.pagamento.length && this.pagamento[0].bloqueio))? false : true
       return (!iscobrancaboletim || (this.pagamento.length && this.pagamento[0].bloqueio))? '' : ls.get('urlReport') + 'readfile/rascunho-1.png'
      } catch (error) {
        return iscobrancaboletim
      }      
     },
     descricaoEscola() {
      let configuracaoInstituto = ls.get('configuracoesReport').filter(c => c.obs === 'nome_escola')
      return (this.instituicaoId === 1) ? (configuracaoInstituto[0].valor).toUpperCase() : (this.$store.state.objAluno.idCurso <= 24 ? this.instituicaodescricao.toUpperCase() : (configuracaoInstituto[1].valor).toUpperCase())
    },
     async comporBoletim () {
       try {
       let boletimAluno = []
       const msgRascunho = '#'
       if (this.trimestre.idTrimestre > 0 && this.trimestre.idTrimestre < 5) {
         this.progresso = true
         // eslint-disable-next-line no-unused-vars
         let classe = this.anoAcademicos.filter(t => t.idAno_academico === this.$store.state.objAluno.idAno_Academico)
         // Boletim do Aluno em função do Trimestre
         if (this.trimestre.idTrimestre === 1)boletimAluno = this.arrayTrimestreFirst
         else
         if (this.trimestre.idTrimestre === 2)boletimAluno = this.arrayTrimestreSecond
         else
         if (this.trimestre.idTrimestre === 3) boletimAluno = this.arrayTrimestreThird
         else
         if (this.trimestre.idTrimestre === 4) {
           boletimAluno = this.listaAlunos
         }
         this.html = this.relatorio[0].documento
         let documentoiter = this.relatorio[0].documentoiteracao1 
         this.html = this.html.replace(/{{instituicaodescricao}}/g, this.descricaoEscola())
         this.html = this.html.replace(/{{insignia}}/g, ls.get('insignia'))
         this.html = this.html.replace(/{{logotipo}}/g, ls.get('logotipo'))
         this.html = this.html.replace(/{{nomeAluno}}/g, this.$store.state.objAluno.nome.toUpperCase())
         this.html = this.html.replace(/{{matricula}}/g, this.$store.state.objAluno.idMAtricula)
         this.html = this.html.replace(/{{anolectivo}}/g, this.$store.state.novadescricaoSelecionado)
         this.html = this.html.replace(/{{curso}}/g, this.$store.state.objAluno.curso)
         this.html = this.html.replace(/{{turma}}/g, this.$store.state.objAluno.turma)
         this.html = this.html.replace(/{{classe}}/g, this.$store.state.objAluno.classe.substring(0, 3))
         this.html = this.html.replace(/{{periodo}}/g, this.$store.state.objAluno.periodo)
         this.html = this.html.replace(/{{dataacual}}/g, utilitario.correntDateByUnderstanding())
         this.html = this.html.replace(/{{trimestre}}/g, this.trimestre.descricao)
         this.html = this.html.replace(/{{rascunho}}/g, this.rascunhoimge)
         let dados = ``
         if (this.trimestre.idTrimestre >= 1 && this.trimestre.idTrimestre <=3) {  
           boletimAluno.forEach(element => {
             let iteracao = documentoiter
             let resultado = this.verifyResultado(element.resultado)
           iteracao = iteracao.replace(/{{disciplina}}/g, element.disciplina)
           iteracao = iteracao.replace(/{{mac}}/g, (this.israscunho ? msgRascunho : this.isNull(element.mac)))
           iteracao = iteracao.replace(/{{p1}}/g, (this.israscunho ? msgRascunho : this.isNull(element.p1)))
           iteracao = iteracao.replace(/{{p2}}/g, (this.israscunho ? msgRascunho : this.isNull(element.p2)))
           iteracao = iteracao.replace(/{{md}}/g, (this.israscunho ? msgRascunho : this.isNull(element.md)))

           iteracao = iteracao.replace(/{{colormac}}/g, (element.mac && element.mac >= 10) ? 'transita' :'NaoTransita')
           iteracao = iteracao.replace(/{{colorp1}}/g, (element.p1 && element.p1 >= 10) ? 'transita' :'NaoTransita')
           iteracao = iteracao.replace(/{{colorp2}}/g, (element.p2 && element.p2 >= 10) ? 'transita' :'NaoTransita')
           iteracao = iteracao.replace(/{{colormd}}/g, (element.md && element.md >= 10) ? 'transita' :'NaoTransita')
           this.html = this.html.replace(/{{resultado}}/g, resultado.valor)
           this.html = this.html.replace(/{{resultadocolor}}/g, resultado.classcolor)
           dados += iteracao
           })
 
           this.html = this.html.replace(/{{css}}/g, this.relatorio[0].css)
           this.html = this.html.replace(/{{dados}}/g, dados)
           let option = { 'format': 'A5' }
           this.boletimgerarPdf(option)
         } else
      
         if (this.trimestre.idTrimestre === 4) {
           boletimAluno.forEach(element => {
             let iteracao = documentoiter
             let resultado = this.verifyResultado(element.resultado)
       iteracao = iteracao.replace(/{{disciplina}}/g, element.disciplina)
       iteracao = iteracao.replace(/{{t1_mac}}/g, (this.israscunho ? msgRascunho : this.isNull(element.t1_mac)))
       iteracao = iteracao.replace(/{{t1_nota1}}/g, (this.israscunho ? msgRascunho : this.isNull(element.t1_nota1)))
       iteracao = iteracao.replace(/{{t1_nota2}}/g, (this.israscunho ? msgRascunho : this.isNull(element.t1_nota2)))
       iteracao = iteracao.replace(/{{t1_md}}/g, (this.israscunho ? msgRascunho : this.isNull(element.t1_md)))

       iteracao = iteracao.replace(/{{colormac}}/g, (element.t1_mac && element.t1_mac >= 10) ? 'transita' :'NaoTransita')
       iteracao = iteracao.replace(/{{colorp1}}/g, (element.t1_nota1 && element.t1_nota1 >= 10) ? 'transita' :'NaoTransita')
       iteracao = iteracao.replace(/{{colorp2}}/g, (element.t1_nota2 && element.t1_nota2 >= 10) ? 'transita' :'NaoTransita')
       iteracao = iteracao.replace(/{{colormd}}/g, (element.t1_md && element.t1_md >= 10) ? 'transita' :'NaoTransita')

       iteracao = iteracao.replace(/{{t2_mac}}/g, (this.israscunho ? msgRascunho : this.isNull(element.t2_mac)))
       iteracao = iteracao.replace(/{{t2_nota1}}/g, (this.israscunho ? msgRascunho : this.isNull(element.t2_nota1)))
       iteracao = iteracao.replace(/{{t2_nota2}}/g, (this.israscunho ? msgRascunho : this.isNull(element.t2_nota2)))
       iteracao = iteracao.replace(/{{t2_md}}/g, (this.israscunho ? msgRascunho : this.isNull(element.t2_md)))

       iteracao = iteracao.replace(/{{color2mac}}/g, (element.t2_mac && element.t2_mac >= 10) ? 'transita' :'NaoTransita')
       iteracao = iteracao.replace(/{{color2p1}}/g, (element.t2_nota1 && element.t2_nota1 >= 10) ? 'transita' :'NaoTransita')
       iteracao = iteracao.replace(/{{color2p2}}/g, (element.t2_nota2 && element.t2_nota2 >= 10) ? 'transita' :'NaoTransita')
       iteracao = iteracao.replace(/{{color2md}}/g, (element.t2_md && element.t2_md >= 10) ? 'transita' :'NaoTransita')

       iteracao = iteracao.replace(/{{t3_mac}}/g, (this.israscunho ? msgRascunho : this.isNull(element.t3_mac)))
       iteracao = iteracao.replace(/{{t3_nota1}}/g, (this.israscunho ? msgRascunho : this.isNull(element.t3_nota1)))       
       iteracao = iteracao.replace(/{{t3_md}}/g, (this.israscunho ? msgRascunho : this.isNull(element.t3_md)))

       iteracao = iteracao.replace(/{{color3mac}}/g, (element.t3_mac && element.t3_mac >= 10) ? 'transita' :'NaoTransita')
       iteracao = iteracao.replace(/{{color3p1}}/g, (element.t3_nota1 && element.t3_nota1 >= 10) ? 'transita' :'NaoTransita')
       iteracao = iteracao.replace(/{{color3md}}/g, (element.t3_md && element.t3_md >= 10) ? 'transita' :'NaoTransita')

       iteracao = iteracao.replace(/{{mfd}}/g, (this.israscunho ? msgRascunho : this.isNull(element.mfd)))
       iteracao = iteracao.replace(/{{colormfd}}/g, (element.mfd && element.mfd >= 10) ? 'transita' :'NaoTransita')

       iteracao = iteracao.replace(/{{exame}}/g, (this.israscunho ? msgRascunho :this.isNull(element.exame)))
       iteracao = iteracao.replace(/{{colorexame}}/g, (element.exame && element.exame >= 10) ? 'transita' :'NaoTransita')

       iteracao = iteracao.replace(/{{recurso}}/g, (this.israscunho ? msgRascunho : this.isNull(element.recurso)))
       iteracao = iteracao.replace(/{{colorrecurso}}/g, (element.recurso && element.recurso >= 10) ? 'transita' :'NaoTransita')
 

       iteracao = iteracao.replace(/{{mf}}/g, (this.israscunho ? msgRascunho : this.isNull(element.mf)))
       iteracao = iteracao.replace(/{{colormf}}/g, (element.mf && element.mf >= 10) ? 'transita' :'NaoTransita')

       this.html = this.html.replace(/{{resultado}}/g, resultado.valor)
       this.html = this.html.replace(/{{resultadocolor}}/g, resultado.classcolor)
       dados += iteracao
           })
       this.html = this.html.replace(/{{css}}/g, this.relatorio[0].css)
       this.html = this.html.replace(/{{dados}}/g, dados)
           let option = { 'format': 'A4' }
           this.boletimgerarPdf(option)
         } 
         this.dialog = false
       }
       } catch (error) {
         Swal.fire({ icon: 'error', title: 'Informação!', text: 'Ocorreu um erro ao compor o relatório' })
       }
       
     },
     verifyResultado (resultado){
      return (resultado && resultado == 'Transita' ) ? {valor: 'Transita', classcolor: 'transita'} : {valor: 'Não Transita', classcolor: 'NaoTransita'} 
    },
     isNull (nota) {
       if (nota) { return nota } else return ''
     },
    
     async boletimgerarPdf (option) {
       try {
         await axios({
           method: 'post',
           url: ls.get('urlReport') + 'writefile',
           data: {
             html: this.html,
             file_name: ls.get('idPessoa'),
             option: option
           }
         }).then(function (response) { })
         // Imprimir PDF 
         this.progresso = false
         this.frameBoletim()
       } catch (error) {
         Swal.fire({ icon: 'error', title: 'Informação!', text: 'Ocorreu um erro ao imprimir'})
         this.progresso = false
       }
     },
     frameBoletim () {
       this.url = ls.get('urlReport') + 'readfile/' + ls.get('idPessoa') + '.pdf'
       let frame = `<html> +
       <style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style> 
       <body>
       <iframe target="_blank" type="application/pdf" src="` + this.url + `"></iframe> 
       </body></html>`
       let a = window.open('about:blank', '_blank', '', true)
       a.document.write(frame)
       a.document.close()
       this.progresso = false
     },
     
     async carregarConfiguracoesReports () {
       try {
         let msg = await axios.post('/configuracoes', { empresa: 'report' }).then(res => res.data)
         if (msg.length > 0) {
           this.configuracoesReport = msg
         }
       } catch (error) {
         Swal.fire({ icon: 'error', title: 'Informação!', text: 'Ocorreu um erro ao carregar as configurações do documento' })
       }
     }
   }
 }
 </script>
 <style>
  .tabela {
     border: 1px solid rgba(0,0,0,.12);
     font-size: 12px!important;
 
 }
  .tabelath {
     border: 1px solid rgba(0,0,0,.12);
     font-size: 12px !important;
 }
 .tdsize {
     width: 3px!important;
 }
 
 </style>
 